import { OptionLevel } from '@cardium/contracts';

export const OptionsLevelsList = [
  { value: null, label: '--' },
  { value: OptionLevel.USER, label: 'Пользователь' },
  { value: OptionLevel.LOCATION, label: 'Кабинет' },
  { value: OptionLevel.ORGANIZATION_UNIT, label: 'Структурное подразделение' },
  { value: OptionLevel.ORGANIZATION, label: 'Организация' },
]
